<div class="side-panel" [class.opened]="open">
	<ng-content></ng-content>
</div>
